export const getPluginFolderName = (folderName) => {
       // remove name space plugin Name
       let removeNameSpacepluginName = folderName;
       let textLowerCase = removeNameSpacepluginName.toLowerCase();
       let setpluginName = textLowerCase.replace(/\s/g, "-");
       return setpluginName;
}